import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { IWorkspace } from 'wisestep-api';
import { ScrollableTabs } from 'wisestep-base';

import { fetchAndSetAssignedUsers } from '../helper/hooks';

import UserAccessAssignedList from './UserAccessAssignedList';
import UserAccessList from './UserAccessList';

export interface IUsersDataStatus {
  workspaceUsers: IWorkspace[];
  totalUsers: number;
}

interface IUserAccessProps {
  email: string;
}

const UserAccess = ({ email }: IUserAccessProps) => {
  const [subTabPanelPage, setSubTabPanelPage] = useState(0);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [assignedUsers, setAssignedUser] = useState<string[]>();

  useEffect(() => {
    const fetchData = async () => {
      setAssignedUser(await fetchAndSetAssignedUsers(email ?? ''));
    };
    fetchData();
  }, [email, refresh]);

  const onAssign = async () => {
    setRefresh(!refresh);
    setSubTabPanelPage(1);
  };

  const userAccessScrollList = [
    { tabName: 'Not Assigned' },
    {
      tabName: 'Assigned',
      tabCount: assignedUsers?.length ?? 0,
    },
  ];

  return (
    <>
      <ScrollableTabs
        scrollList={userAccessScrollList}
        getTabIndex={setSubTabPanelPage}
        defaultValue={subTabPanelPage}
      />
      {subTabPanelPage === 0 && (
        <Grid container p={3} mb={5}>
          <UserAccessList
            onAssign={onAssign}
            assignedUsers={assignedUsers}
            loggedInUser={email ?? ''}
          />
        </Grid>
      )}
      {subTabPanelPage === 1 && (
        <Grid container p={2}>
          <UserAccessAssignedList
            onAssign={onAssign}
            assignedUsers={assignedUsers}
            loggedInUser={email ?? ''}
          />
        </Grid>
      )}
    </>
  );
};

export default UserAccess;
